<!-- <form #selectComponentForm="ngForm" class="sas-select-wrapper {{sasClass}}"> -->
<div class="sas-select-wrapper {{sasClass}}">
  <!-- ng-class="{'has-error': selectComponentForm.{{$ctrl.name}}.$invalid &&
                           (selectComponentForm.{{$ctrl.name}}.$dirty || $ctrl.isFormSubmitted)}"> -->
  <label [for]="instanceId"
         [id]="labelId + 'label'"
         class="form-label"
         [hidden]="hideLabel"
         title="{{helpText | translate}}"
         [textContent]="label"
         translate="{{label}}"
         [ngClass]="{'has-error': name.invalid && (name.dirty || name.touched)}">
  </label>
  <span *ngIf="validation !== undefined && validation.required"> *</span>
  <div *ngIf="sasHelptext" [title]="sasHelptext | translate" class="sas-inline-block">
    <i class="bi bi-info-circle-fill" style="font-size: 15px; cursor: help; margin-left: 5px;"></i>
  </div>
  <!-- []="item.id as item.name for item in $ctrl.items" -->
  <select name="name"
          [id]="instanceId"
          class="form-select  sas-select  {{sasClass}}"
          title="{{helpText | translate}}"
          [ngClass]="{'invalid-feedback': name.invalid && (name.dirty || name.touched)}"
          [(ngModel)]="model"
          #name="ngModel"
          (change)="onSelect()"
          [disabled]="disabled"
          [required]="validation !== undefined && validation.required !== undefined && validation.required"
          tabindex="0"
          [ariaDisabled]="disabled"
          [attr.aria-label]="label | translate"
          [attr.aria-labelledby]="sasId + 'label'"
          [attr.aria-required]="ariaRequired">
    <option [ngValue]="undefined" *ngIf="defaultText">{{defaultText | translate}}</option>
    <option *ngFor="let item of items" [ngValue]="item.id">{{item.name}}</option>
  </select>
  <div class="invalid-feedback" role="alert" *ngIf="name.invalid && (name.dirty || name.touched)">
    <small class="ng-invalid text-danger" *ngIf="name.errors?.['required']">
      error {{ (validation !== undefined && validation.required !== undefined ) ? validation.requiredText : '' | translate }}
    </small>
  </div>

</div>
